/*
 * @Author: your name
 * @Date: 2021-09-22 17:36:26
 * @LastEditTime: 2021-10-26 14:19:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /soci-frontend/src/route/routes.js
 */
import home from '@/components/main.vue'
import login from '@/components/login.vue'


export default [
    {
        path: '/login',
        name: 'login',
        component: login,
    },
    {
        path: '/',
        name: "home",
        component: home,
        children: [
            {
                path: 'facebookPeople',
                name: 'facebookPeople',
                component: () => import('@/view/facePeople.vue')
            },
            {
                path: 'facebookTopic',
                name: 'facebookTopic',
                component: () => import('@/view/facebookTopic.vue')
            },
            {
                path: 'douyinPeople',
                name: 'douyinPeople',
                component: () => import('@/view/douyinPeople.vue')
            },
            {
                path: 'douyinVideo',
                name: 'douyinVideo',
                component: () => import('@/view/douyinVideo.vue')
            },
            {
                path: 'kuaishouPeople',
                name: 'kuaishouPeople',
                component: () => import('@/view/kuaishouPeople.vue')
            },
            {
                path: 'kuaishouVideo',
                name: 'kuaishouVideo',
                component: () => import('@/view/kuaishouVideo.vue')
            },
            {
                path: 'redbookPeople',
                name: 'redbookPeople',
                component: () => import('@/view/redbookPeople.vue')
            },
            {
                path: 'redbookNote',
                name: 'redbookNote',
                component: () => import('@/view/redbookNote.vue')
            },
            {
                path: 'youtubeVideo',
                name: 'youtubeVideo',
                component: () => import('@/view/youtubeVideo.vue')
            },
            {
                path: 'insPeople',
                name: 'insPeople',
                component: () => import('@/view/insPeople.vue')
            },
            {
                path: 'insNote',
                name: 'insNote',
                component: () => import('@/view/insNote.vue')
            },
            {
                path: 'twitterPeople',
                name: 'twitterPeople',
                component: () => import('@/view/twitterPeople.vue')
            },
            {
                path: 'twitterTopic',
                name: 'twitterTopic',
                component: () => import('@/view/twitterTopic.vue')
            },
            {
                path: 'watermarkTools',
                name: 'watermarkTools',
                component: () => import('@/view/watermarkTools.vue')
            },
            {
              path: 'generateDouCode',
              name: 'generateDouCode',
              component: () => import('@/view/generateDouCode.vue')
            },
            {
              path: 'honorCaptureImages',
              name: 'honorCaptureImages',
              component: () => import('@/view/honorCaptureImages.vue')
            },
          // {
          //   path: 'maidongTmpImages',
          //   name: 'maidongTmpImages',
          //   component: () => import('@/view/maidongTmpImages.vue')
          // },
            {
                path: 'pinterestImage',
                name: 'pinterestImage',
                component: () => import('@/view/pinterestImage.vue')
            },
          {
            path: 'douyinLiveRooms',
            name: 'douyinLiveRooms',
            component: () => import('@/view/douyinLiveRooms.vue')
          },
          {
            path: 'kuaishouLiveRooms',
            name: 'kuaishouLiveRooms',
            component: () => import('@/view/kuaishouLiveRooms.vue')
          },
          {
            path: 'searchSiteAdvInfo',
            name: 'searchSiteAdvInfo',
            component: () => import('@/view/searchSiteAdvInfo.vue')
          },
          {
            path: 'tiktokGoodsItem',
            name: 'tiktokGoodsItem',
            component: () => import('@/view/tiktokGoodsItem.vue')
          },
          {
            path: 'tiktokVideoItem',
            name: 'tiktokVideoItem',
            component: () => import('@/view/tiktokVideoItem.vue')
          },
          {
            path: 'tiktokUserItem',
            name: 'tiktokUserItem',
            component: () => import('@/view/tiktokUserItem.vue')
          },
          {
            path: 'douyinBillboardGoodsItem',
            name: 'douyinBillboardGoodsItem',
            component: () => import('@/view/douyinBillboardGoodsItem.vue')
          },
          {
            path: 'douyinShopGoodsItem',
            name: 'douyinShopGoodsItem',
            component: () => import('@/view/douyinShopGoodsItem.vue')
          },
          {
            path: 'tiktokScreenShot',
            name: 'tiktokScreenShot',
            component: () => import('@/view/tiktokScreenShot.vue')
          },
          {
            path: 'diantaoLiveRooms',
            name: 'diantaoLiveRooms',
            component: () => import('@/view/diantaoLiveRooms.vue')
          },
          {
            path: 'baiduLiveRooms',
            name: 'baiduLiveRooms',
            component: () => import('@/view/baiduLiveRooms.vue')
          },
          {
            path: 'pddLiveRooms',
            name: 'pddLiveRooms',
            component: () => import('@/view/pddLiveRooms.vue')
          },
            {
                path: 'diantaoLiveShevles',
                name: 'diantaoLiveShevles',
                component: () => import('@/view/diantaoLiveShevles.vue')
            },
            {
                path: 'wechatArtDetails',
                name: 'wechatArtDetails',
                component: () => import('@/view/wechatArtDetails.vue')
            },
            {
                path: 'douyinGroupMallDetails',
                name: 'douyinGroupMallDetails',
                component: () => import('@/view/douyinGroupMalldetails.vue')
            },

            {
                path: 'generateJdShortLink',
                name: 'generateJdShortLink',
                component: () => import('@/view/generateJdShortLink.vue')
            },
            {
                path: 'generatetbShortLink',
                name: 'generatetbShortLink',
                component: () => import('@/view/generatetbShortLink.vue')
            },
            {
                path: 'generatedyShortLink',
                name: 'generatedyShortLink',
                component: () => import('@/view/generatedyShortLink.vue')
            },
            {
                path: 'wechatVideoInfoDetails',
                name: 'wechatVideoInfoDetails',
                component: () => import('@/view/wechatVideoInfoDetails.vue')
            },
            {
                path: 'kuaishouPlaybackDetails',
                name: 'kuaishouPlaybackDetails',
                component: () => import('@/view/kuaishouPlaybackDetails.vue')
            },


        ]
    },
]
